
import { computed, defineComponent } from '@nuxtjs/composition-api'
import { convertNewlines } from '~/assets/ts/textFormat'

export default defineComponent({
  name: 'CatalogEmotionImage',
  props: {
    image: {
      type: String,
      required: true,
    },
  },
  methods: {
    convertNewlines,
  },
  setup(props) {

    const showText = computed(() => {
      // if an individual image is being displayed, hide the textbox
      if (props.image.endsWith('.jpg') || props.image.endsWith('.webp')) {
        return false
      }
      return true
    })

    const imageFilename = computed(() => {
      // if an individual image is being displayed return the specific image
      if (props.image.endsWith('.jpg') || props.image.endsWith('.webp')) {
        return require('~/assets/img/catalog/' + props.image)
      }
      return require('~/assets/img/catalog/emotion-' + props.image + '@2x.jpg')
    })

    return {
      showText,
      imageFilename,
    }
  }
})
